/**
 * @generated SignedSource<<9353f4ca4dfa558b3e767c2cb8a21574>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type finishTransactionDetailPageQuery$variables = {
  id: string;
};
export type finishTransactionDetailPageQuery$data = {
  readonly instantBuy: {
    readonly hub: {
      readonly id: string;
      readonly meta: {
        readonly city: string;
        readonly country: string;
        readonly id: string;
        readonly name: string;
        readonly organization: {
          readonly logo: {
            readonly variant: string;
          } | null | undefined;
        };
        readonly postalCode: string;
        readonly street: string;
      };
    };
    readonly id: string;
    readonly lineItems: ReadonlyArray<{
      readonly id: string;
      readonly priceAmount: number;
      readonly productInstance: {
        readonly hubProduct: {
          readonly id: string;
          readonly product: {
            readonly brand: {
              readonly id: string;
              readonly name: string;
            };
            readonly description: string | null | undefined;
            readonly id: string;
            readonly name: string;
            readonly photo: {
              readonly variant: string;
            };
            readonly " $fragmentSpreads": FragmentRefs<"productDetailCardProduct">;
          };
        };
        readonly id: string;
        readonly reservation: {
          readonly space: {
            readonly frame: string;
            readonly position: number;
          };
        };
      };
      readonly " $fragmentSpreads": FragmentRefs<"financialDetailCardLineItems">;
    }>;
    readonly user: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"userDetailCardUser">;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"transactionDetailCardVendingTransaction">;
  } | null | undefined;
};
export type finishTransactionDetailPageQuery = {
  response: finishTransactionDetailPageQuery$data;
  variables: finishTransactionDetailPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "by"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "street",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "country",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "variant",
      "value": "PUBLIC"
    }
  ],
  "kind": "ScalarField",
  "name": "variant",
  "storageKey": "variant(variant:\"PUBLIC\")"
},
v9 = [
  (v8/*:: as any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Organization",
  "kind": "LinkedField",
  "name": "organization",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CloudflareImage",
      "kind": "LinkedField",
      "name": "logo",
      "plural": false,
      "selections": (v9/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "frame",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "VendingReservation",
  "kind": "LinkedField",
  "name": "reservation",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v11/*:: as any*/),
        (v12/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "concreteType": "Brand",
  "kind": "LinkedField",
  "name": "brand",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v3/*:: as any*/)
  ],
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceAmount",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "active",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v22 = [
  (v2/*:: as any*/),
  (v17/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "finishTransactionDetailPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "InstantBuy",
        "kind": "LinkedField",
        "name": "instantBuy",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "transactionDetailCardVendingTransaction"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "userDetailCardUser"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "hub",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "HubMeta",
                  "kind": "LinkedField",
                  "name": "meta",
                  "plural": false,
                  "selections": [
                    (v2/*:: as any*/),
                    (v3/*:: as any*/),
                    (v4/*:: as any*/),
                    (v5/*:: as any*/),
                    (v6/*:: as any*/),
                    (v7/*:: as any*/),
                    (v10/*:: as any*/)
                  ],
                  "storageKey": null
                },
                "action": "THROW"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LineItem",
            "kind": "LinkedField",
            "name": "lineItems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "financialDetailCardLineItems"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductInstance",
                "kind": "LinkedField",
                "name": "productInstance",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v13/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubProduct",
                    "kind": "LinkedField",
                    "name": "hubProduct",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          (v3/*:: as any*/),
                          (v14/*:: as any*/),
                          (v15/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloudflareImage",
                            "kind": "LinkedField",
                            "name": "photo",
                            "plural": false,
                            "selections": (v9/*:: as any*/),
                            "storageKey": null
                          },
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "productDetailCardProduct"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v16/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "finishTransactionDetailPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "InstantBuy",
        "kind": "LinkedField",
        "name": "instantBuy",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientReferenceId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripeSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Hub",
            "kind": "LinkedField",
            "name": "hub",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v19/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "HubMeta",
                "kind": "LinkedField",
                "name": "meta",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  (v3/*:: as any*/),
                  (v4/*:: as any*/),
                  (v5/*:: as any*/),
                  (v7/*:: as any*/),
                  (v6/*:: as any*/),
                  (v10/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "LineItem",
            "kind": "LinkedField",
            "name": "lineItems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v16/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductInstance",
                "kind": "LinkedField",
                "name": "productInstance",
                "plural": false,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "HubProduct",
                    "kind": "LinkedField",
                    "name": "hubProduct",
                    "plural": false,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v2/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "vat",
                            "storageKey": null
                          },
                          (v3/*:: as any*/),
                          (v14/*:: as any*/),
                          (v15/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CloudflareImage",
                            "kind": "LinkedField",
                            "name": "photo",
                            "plural": false,
                            "selections": [
                              (v8/*:: as any*/),
                              (v2/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v20/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "defaultPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Category",
                            "kind": "LinkedField",
                            "name": "category",
                            "plural": false,
                            "selections": [
                              (v2/*:: as any*/),
                              (v3/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "i18N",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "HubProductPage",
                            "kind": "LinkedField",
                            "name": "hubProducts",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "HubProduct",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                  (v2/*:: as any*/),
                                  (v20/*:: as any*/),
                                  (v16/*:: as any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "stock",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Hub",
                                    "kind": "LinkedField",
                                    "name": "hub",
                                    "plural": false,
                                    "selections": [
                                      (v2/*:: as any*/),
                                      (v19/*:: as any*/),
                                      (v21/*:: as any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "HubMeta",
                                        "kind": "LinkedField",
                                        "name": "meta",
                                        "plural": false,
                                        "selections": [
                                          (v2/*:: as any*/),
                                          (v3/*:: as any*/),
                                          (v4/*:: as any*/),
                                          (v5/*:: as any*/),
                                          (v7/*:: as any*/),
                                          (v6/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "filter",
                                        "value": {
                                          "inHub": true
                                        }
                                      }
                                    ],
                                    "concreteType": "ProductInstancePage",
                                    "kind": "LinkedField",
                                    "name": "productInstances",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "totalCount",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductInstance",
                                        "kind": "LinkedField",
                                        "name": "nodes",
                                        "plural": true,
                                        "selections": [
                                          (v2/*:: as any*/),
                                          (v17/*:: as any*/),
                                          (v18/*:: as any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UnlockRequest",
                                            "kind": "LinkedField",
                                            "name": "filledWith",
                                            "plural": false,
                                            "selections": (v22/*:: as any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "UnlockRequest",
                                            "kind": "LinkedField",
                                            "name": "retrievedWith",
                                            "plural": false,
                                            "selections": (v22/*:: as any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "VendingReservation",
                                            "kind": "LinkedField",
                                            "name": "reservation",
                                            "plural": false,
                                            "selections": [
                                              (v2/*:: as any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Space",
                                                "kind": "LinkedField",
                                                "name": "space",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*:: as any*/),
                                                  (v12/*:: as any*/),
                                                  (v11/*:: as any*/),
                                                  (v21/*:: as any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "deviceId",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "productInstances(filter:{\"inHub\":true})"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v13/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "23c21e9ee0d818bb414f3c719db7c30f",
    "id": null,
    "metadata": {},
    "name": "finishTransactionDetailPageQuery",
    "operationKind": "query",
    "text": "query finishTransactionDetailPageQuery(\n  $id: UUID!\n) {\n  instantBuy(by: {id: $id}) {\n    id\n    ...transactionDetailCardVendingTransaction\n    user {\n      id\n      ...userDetailCardUser\n    }\n    hub {\n      id\n      meta {\n        id\n        name\n        street\n        city\n        country\n        postalCode\n        organization {\n          logo {\n            variant(variant: PUBLIC)\n          }\n        }\n      }\n    }\n    lineItems {\n      id\n      ...financialDetailCardLineItems\n      productInstance {\n        id\n        reservation {\n          space {\n            frame\n            position\n          }\n        }\n        hubProduct {\n          id\n          product {\n            id\n            name\n            description\n            brand {\n              id\n              name\n            }\n            photo {\n              variant(variant: PUBLIC)\n            }\n            ...productDetailCardProduct\n          }\n        }\n      }\n      priceAmount\n    }\n  }\n}\n\nfragment financialDetailCardLineItems on LineItem {\n  id\n  priceAmount\n  productInstance {\n    id\n    hubProduct {\n      id\n      product {\n        id\n        vat\n      }\n    }\n  }\n}\n\nfragment productDetailCardProduct on Product {\n  id\n  name\n  description\n  active\n  photo {\n    id\n    variant(variant: PUBLIC)\n  }\n  defaultPrice\n  brand {\n    id\n    name\n  }\n  category {\n    id\n    name\n    i18N\n  }\n  vat\n  hubProducts {\n    nodes {\n      id\n      active\n      priceAmount\n      stock\n      hub {\n        id\n        slug\n        status\n        meta {\n          id\n          name\n          street\n          city\n          postalCode\n          country\n        }\n      }\n      productInstances(filter: {inHub: true}) {\n        totalCount\n        nodes {\n          id\n          createdAt\n          updatedAt\n          filledWith {\n            id\n            createdAt\n          }\n          retrievedWith {\n            id\n            createdAt\n          }\n          reservation {\n            id\n            space {\n              id\n              position\n              frame\n              status\n              deviceId\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment transactionDetailCardVendingTransaction on InstantBuy {\n  id\n  createdAt\n  updatedAt\n  clientReferenceId\n  stripeSessionId\n  hub {\n    id\n    slug\n    meta {\n      id\n      name\n      street\n      city\n      postalCode\n    }\n  }\n}\n\nfragment userDetailCardUser on User {\n  id\n  name\n  firstName\n  lastName\n  email\n}\n"
  }
};
})();

(node as any).hash = "5b05955f0c718c2925ce088c0e85bb87";

export default node;
